export default "__VITE_ASSET__c22a7c11__"